<!-- eslint-disable vue/no-mutating-props -->
<!--
  Bloco de formulário de trocas de UM time (Task 4). Edita `config` IN-PLACE via
  v-model/applyHandoverRestrictionMode — mesma referência de objeto mantida pelo
  pai (edição e criação, Tasks 5/6), mesmo padrão de SurveyQuestionCard.vue —
  daí o eslint-disable de vue/no-mutating-props no topo.
-->
<template>
  <div class="flex flex-col gap-y-6">
    <div class="flex flex-col gap-4">
      <p class="font-bold text-[16px] text-[#323232] text-left">Restrição de trocas</p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <SelectableCard
          :data-testid="`${testidPrefix}-restriction-disabled`"
          title="Desabilitar trocas pelo aplicativo"
          description="Os médicos escalados nessa escala não poderão trocar seus plantões através do aplicativo."
          :selected="!config.allowDoctorStationHandover"
          @click="handleSelectRestriction('disabled')"
        />
        <SelectableCard
          :data-testid="`${testidPrefix}-restriction-admin-only`"
          title="Apenas trocas aprovadas pelo painel web"
          description="Os médicos escalados poderão trocar seus plantões, porém apenas com autorização através do painel administrativo."
          :selected="config.allowDoctorStationHandover && config.requiresAdminApproval"
          @click="handleSelectRestriction('admin_only')"
        />
        <SelectableCard
          :data-testid="`${testidPrefix}-restriction-enabled`"
          title="Habilitar trocas pelo aplicativo"
          description="Médicos poderão trocar seus plantões com outros médicos através do aplicativo mobile sem a necessidade de aprovação de terceiros."
          :selected="config.allowDoctorStationHandover && !config.requiresAdminApproval"
          @click="handleSelectRestriction('enabled')"
        />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <p class="font-bold text-[16px] text-[#323232] text-left">Prazo para solicitar troca</p>
      <p class="text-[14px] text-[#808080] text-left">
        <span class="font-bold">Exemplo:</span>
        {{ exchangeDeadlineExample }}
      </p>

      <div class="flex items-center gap-4">
        <p class="text-[16px] text-[#323232] whitespace-nowrap">Solicitar trocas até</p>
        <v-autocomplete
          v-model="config.handoverRequestHours"
          :data-testid="`${testidPrefix}-request-hours`"
          :items="REQUEST_LEAD_TIME_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverRequestHours"
          :error-messages="errors.handoverRequestHours"
          @update:modelValue="onClearError('handoverRequestHours')"
        >
          <template #label>
            <span>Antecedência <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="config.handoverRequestTiming"
          :data-testid="`${testidPrefix}-request-timing`"
          :items="WHEN_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverRequestTiming"
          :error-messages="errors.handoverRequestTiming"
          @update:modelValue="onClearError('handoverRequestTiming')"
        >
          <template #label>
            <span>Quando <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="config.handoverRequestReference"
          :data-testid="`${testidPrefix}-request-reference`"
          :items="EVENT_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverRequestReference"
          :error-messages="errors.handoverRequestReference"
          @update:modelValue="onClearError('handoverRequestReference')"
        >
          <template #label>
            <span>Evento <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <p class="font-bold text-[16px] text-[#323232] text-left">Prazo de expiração do convite</p>
      <p class="text-[14px] text-[#808080] text-left">
        <span class="font-bold">Exemplo:</span>
        {{ inviteExpirationExample }}
      </p>

      <div class="flex items-center gap-4">
        <p class="text-[16px] text-[#323232] whitespace-nowrap">Convites expiram</p>
        <v-autocomplete
          v-model="config.handoverExpirationHours"
          :data-testid="`${testidPrefix}-expiration-hours`"
          :items="LEAD_TIME_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverExpirationHours"
          :error-messages="errors.handoverExpirationHours"
          @update:modelValue="onClearError('handoverExpirationHours')"
        >
          <template #label>
            <span>Antecedência <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="config.handoverExpirationTiming"
          :data-testid="`${testidPrefix}-expiration-timing`"
          :items="WHEN_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverExpirationTiming"
          :error-messages="errors.handoverExpirationTiming"
          @update:modelValue="onClearError('handoverExpirationTiming')"
        >
          <template #label>
            <span>Quando <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="config.handoverExpirationReference"
          :data-testid="`${testidPrefix}-expiration-reference`"
          :items="EVENT_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.allowDoctorStationHandover"
          :error="!!errors.handoverExpirationReference"
          :error-messages="errors.handoverExpirationReference"
          @update:modelValue="onClearError('handoverExpirationReference')"
        >
          <template #label>
            <span>Evento <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
      </div>
    </div>

    <div v-if="flags.enabledConsecutiveHoursLimit" class="flex flex-col gap-2">
      <p class="font-bold text-[16px] text-[#323232] text-left">Jornada (regra desta escala)</p>
      <p class="text-[14px] text-[#808080] text-left">
        <span class="font-bold">Exemplo:</span>
        {{ consecutiveHoursExample }}
      </p>

      <DsSwitch
        :model-value="config.limitConsecutiveHours"
        label="Limitar horas consecutivas nesta escala"
        :data-testid="`${testidPrefix}-limit-consecutive-hours-switch`"
        @update:model-value="handleToggleConsecutiveHours"
      />

      <DsSwitch
        v-model="config.consecutiveHoursOurTeamOnly"
        label="Contabilizar apenas plantões como equipe interna"
        :disabled="!config.limitConsecutiveHours"
        :data-testid="`${testidPrefix}-consecutive-hours-our-team-only-switch`"
      />

      <div class="flex items-center gap-4 mt-2">
        <p class="text-[16px] text-[#323232] whitespace-nowrap">Um médico pode ficar no máximo</p>
        <v-autocomplete
          v-model="config.maxConsecutiveHours"
          :data-testid="`${testidPrefix}-max-consecutive-hours`"
          :items="CONSECUTIVE_HOURS_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.limitConsecutiveHours"
          :error="!!errors.maxConsecutiveHours"
          :error-messages="errors.maxConsecutiveHours"
          @update:modelValue="onClearError('maxConsecutiveHours')"
        >
          <template #label>
            <span>Máximo de horas consecutivas <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-model="config.minRestHours"
          :data-testid="`${testidPrefix}-min-rest-hours`"
          :items="CONSECUTIVE_HOURS_OPTIONS"
          item-title="title"
          item-value="value"
          variant="outlined"
          color="primary20"
          density="compact"
          hide-details="auto"
          :disabled="!config.limitConsecutiveHours"
          :error="!!errors.minRestHours"
          :error-messages="errors.minRestHours"
          @update:modelValue="onClearError('minRestHours')"
        >
          <template #label>
            <span>Pausa mínima para retornar <span class="text-[#DA1E28]">*</span></span>
          </template>
        </v-autocomplete>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SelectableCard from '@/components/designSystem/Cards/SelectableCard.vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import {
  LEAD_TIME_OPTIONS,
  REQUEST_LEAD_TIME_OPTIONS,
  CONSECUTIVE_HOURS_OPTIONS,
  WHEN_OPTIONS,
  EVENT_OPTIONS,
  TEAM_HANDOVER_VALIDATION_RULES,
  TEAM_CONSECUTIVE_HOURS_VALIDATION_RULES,
  applyHandoverRestrictionMode,
  applyConsecutiveHoursToggle,
  buildHandoverExampleText,
  buildConsecutiveHoursExampleText,
  type TeamHandoverConfig,
  type HandoverRestrictionMode
} from '@/constants/handover.constants'

const props = defineProps<{
  config: TeamHandoverConfig
  errors: Record<string, string>
  onClearError: (field: string) => void
  testidPrefix: string
}>()

const { flags } = useFeatureFlags()

function handleSelectRestriction(mode: HandoverRestrictionMode) {
  applyHandoverRestrictionMode(props.config, mode)
  if (mode === 'disabled') {
    Object.keys(TEAM_HANDOVER_VALIDATION_RULES).forEach((field) => props.onClearError(field))
  }
}

// A seção de jornada é independente da restrição de trocas: só o próprio toggle a governa.
function handleToggleConsecutiveHours(value: boolean) {
  applyConsecutiveHoursToggle(props.config, value)
  if (!value) {
    Object.keys(TEAM_CONSECUTIVE_HOURS_VALIDATION_RULES).forEach((field) =>
      props.onClearError(field)
    )
  }
}

const consecutiveHoursExample = computed(() =>
  buildConsecutiveHoursExampleText(
    props.config.limitConsecutiveHours,
    props.config.maxConsecutiveHours,
    props.config.minRestHours,
    props.config.consecutiveHoursOurTeamOnly
  )
)

const exchangeDeadlineExample = computed(
  () =>
    buildHandoverExampleText(
      props.config.handoverRequestHours,
      props.config.handoverRequestTiming,
      props.config.handoverRequestReference
    ) || ' Solicitar trocas até 4 horas depois do fim do plantão'
)

const inviteExpirationExample = computed(
  () =>
    buildHandoverExampleText(
      props.config.handoverExpirationHours,
      props.config.handoverExpirationTiming,
      props.config.handoverExpirationReference
    ) || ' Convites expiram 48 horas antes do início do plantão'
)
</script>
